import React from "react";
import { Button } from "react-materialize";
import $ from "jquery";
import { useAlluser } from "context/AlluserContext";

export default function Btn({ setReqData, setActionData }) {
  const { filters, defaultFilters, storeFilters } = useAlluser();
  const handleEvents = {
    BtnClear: {
      OnClick: function (evt) {
        evt.preventDefault();
        storeFilters({
          ...defaultFilters,
          limit: $("#select-limit-row").val(),
        });
        setReqData({ status: "", err: 0, err_msg: "" });
        setActionData({ key: 0, items: [], checked: false, pages: [] });
      },
    },
    BtnSearch: {
      OnClick: function (evt) {
        evt.preventDefault();
        let arr = ["country"];
        let isEmpty = false;
        for (const i in arr) {
          const name = arr[i];
          const helper = $("#helper-text-" + name);
          if (filters?.[name] === undefined || filters?.[name].length === 0) {
            isEmpty = true;
            helper.removeClass("hide");
          } else {
            helper.addClass("hide");
          }
        }
        if (isEmpty) {
          return;
        }
        storeFilters({
          ...filters,
          limit: $("#select-limit-row").val(),
          page: 1,
        });
        setReqData({ status: "", err: 0, err_msg: "" });
        setActionData({ key: 0, items: [], checked: false, pages: [] });
      },
    },
  };
  // console.log("filters", filters);
  return (
    <div id="main-btn" className="row" style={{}}>
      <Button
        node="button"
        type="button"
        className="blue-grey lighten-5"
        id="btn-clear"
        onClick={handleEvents.BtnClear.OnClick}
      >
        Clear All
      </Button>
      <Button
        node="button"
        id="btn-search"
        onClick={handleEvents.BtnSearch.OnClick}
      >
        Search
      </Button>
    </div>
  );
}
